import { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../component/Layout";
import { useNavigate } from "react-router-dom";
const Settings = () => {
  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = useState(false);
  const [smtpSettings, setSmtpSettings] = useState({
    host: "",
    port: "",
    username: "",
    password: "",
    security: "ssl", // default SSL seçili olsun
  });

  useEffect(() => {
    const isAdmin = sessionStorage.getItem('isAdmin') === 'true';
    if (!isAdmin) {
      navigate('/dashboard');
      return;
    }
    const savedSettings = JSON.parse(localStorage.getItem("smtpSettings")) || {
      host: "",
      port: "",
      username: "",
      password: "",
      security: "ssl",
    };
    setSmtpSettings(savedSettings);
  }, []);

  const handleSave = () => {
    localStorage.setItem("smtpSettings", JSON.stringify(smtpSettings));
    setShowSuccess(true);
  };

  return (
    <>
      <Helmet>
        <title>Ayarlar</title>
        <meta name="description" content="SMTP yapılandırma ayarları" />
      </Helmet>
      <Layout pageTitle="SMTP Ayarları">
      {showSuccess && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50 transition-opacity duration-300">
    <div className="bg-white rounded-lg p-6 shadow-xl max-w-md w-full text-center animate-fade-in-up">
      <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
        <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h3 className="mt-4 text-lg font-semibold text-gray-900">Kayıt Başarılı</h3>
      <p className="mt-2 text-sm text-gray-500">
        SMTP ayarlarınız başarıyla kaydedildi.
      </p>

      <div className="mt-6 flex justify-center gap-4">
        <button
          onClick={() => setShowSuccess(false)}
          className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700"
        >
          Tamam
        </button>
      </div>
    </div>
  </div>
)}
        <div className="p-6 max-w-2xl mx-auto bg-white rounded shadow-md">
          <h2 className="text-2xl font-bold mb-6">SMTP Yapılandırması</h2>

          <div className="space-y-4">
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">SMTP Sunucu</label>
              <input
                type="text"
                className="w-full p-2 border rounded"
                placeholder="smtp.domain.com"
                value={smtpSettings.host}
                onChange={(e) => setSmtpSettings({ ...smtpSettings, host: e.target.value })}
              />
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">Port</label>
              <input
                type="number"
                className="w-full p-2 border rounded"
                placeholder="587"
                value={smtpSettings.port}
                onChange={(e) => setSmtpSettings({ ...smtpSettings, port: e.target.value })}
              />
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">Kullanıcı Adı</label>
              <input
                type="text"
                className="w-full p-2 border rounded"
                placeholder="kullanici@domain.com"
                value={smtpSettings.username}
                onChange={(e) => setSmtpSettings({ ...smtpSettings, username: e.target.value })}
              />
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">Şifre</label>
              <input
                type="password"
                className="w-full p-2 border rounded"
                placeholder="Şifreniz"
                value={smtpSettings.password}
                onChange={(e) => setSmtpSettings({ ...smtpSettings, password: e.target.value })}
              />
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">Güvenlik Türü</label>
              <select
                className="w-full p-2 border rounded"
                value={smtpSettings.security}
                onChange={(e) => setSmtpSettings({ ...smtpSettings, security: e.target.value })}
              >
                <option value="ssl">SSL</option>
                <option value="tls">TLS</option>
              </select>
            </div>

            <div className="flex justify-end mt-6">
              <button
                onClick={handleSave}
                className="px-6 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded"
              >
                Kaydet
              </button>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Settings;
